import type { LocationDescriptor } from 'history';
import type { HTMLAttributes } from 'react';

export interface JoinTeamSectionData {
  link: LocationDescriptor;
}

export interface JoinTeamSectionProps extends HTMLAttributes<HTMLDivElement>, JoinTeamSectionData {}
